import React from 'react';

import { InfoIcon } from '@assets/icons';
import CustomIcon from '@components/utils/CustomIcon';
import { FlexibleDiv } from '@components/formStyles';

import { ErrorMessageWrapper, ErrorMessageContent } from './GuestBoxStyle';

const ErrorMessage = ({ errorMessages = [] }: { errorMessages: string[] }) => {
  return errorMessages?.length ? (
    <ErrorMessageWrapper>
      {errorMessages?.map((errorMessage) => (
        <ErrorMessageContent key={errorMessage}>
          <FlexibleDiv top={2} right={3}>
            <CustomIcon icon={InfoIcon} fontSize={15} paletteColor='tomato' />
          </FlexibleDiv>
          <span>{errorMessage}</span>
        </ErrorMessageContent>
      ))}
    </ErrorMessageWrapper>
  ) : null;
};

export default ErrorMessage;
